import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_3 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_4 = {
  key: 0,
  class: "bg-gray-50"
}
const _hoisted_5 = {
  colspan: "3",
  class: "px-6 py-3 text-sm font-semibold text-black"
}
const _hoisted_6 = { class: "hover:bg-gray-50" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_8 = { class: "px-3 py-2 text-sm text-black bg-gray-50 rounded-md border border-gray-200" }
const _hoisted_9 = { class: "px-6 py-4" }
const _hoisted_10 = { class: "flex gap-1 flex-wrap" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-black" }
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

import type { PackageItem } from '@/types/pack'

interface Props {
  packages: PackageItem[]
}

interface Emits {
  (e: 'edit', packageId: number): void
  (e: 'delete', packageId: number): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PackageTable',
  props: {
    packages: {}
  },
  emits: ["edit", "delete"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("thead", { class: "bg-gray-50" }, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, " Titre "),
          _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, " Quantité "),
          _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider" }, " Action ")
        ])
      ], -1)),
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (pkg, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: pkg.id
          }, [
            (index === 0 || pkg.nombreTailles !== _ctx.packages[index - 1].nombreTailles)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _createElementVNode("td", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "section-header", { item: pkg }, () => [
                      _createTextVNode(" Taille paquet : " + _toDisplayString(pkg.nombreTailles), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", _hoisted_7, [
                _renderSlot(_ctx.$slots, "titre", { item: pkg }, () => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(pkg.titre), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _renderSlot(_ctx.$slots, "quantites", { item: pkg }, () => [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pkg.quantites, (quantite, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "px-3 py-1.5 text-sm text-center text-white bg-blue-600 rounded font-medium"
                      }, _toDisplayString(quantite), 1))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_11, [
                _renderSlot(_ctx.$slots, "action", { item: pkg }, () => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.$emit('edit', pkg.id)),
                      class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                    }, _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "fas fa-edit mr-1" }, null, -1),
                      _createTextVNode(" Modifier ")
                    ]), 8, _hoisted_13),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.$emit('delete', pkg.id)),
                      class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                    }, _cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fas fa-trash mr-1" }, null, -1),
                      _createTextVNode(" Supprimer ")
                    ]), 8, _hoisted_14)
                  ])
                ])
              ])
            ])
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})